export default "__VITE_ASSET__c6069a0c__"